import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { Router } from '@angular/router';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';

@Component({
  selector: 'app-report-education-tab',
  templateUrl: './report-education-tab.component.html',
  styleUrls: ['./report-education-tab.component.scss']
})
export class ReportEducationTabComponent implements OnInit {

  constructor( private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService, private router: Router,
  private talentInsightsReqHandlerService: TalentInsightsReqHandlerService, private aggReqObjectHandlerService: AggReqObjectHandlerService,
  private aggService: AggregationService, private filterDataHandlerService: FilterDataHandlerService,
  private hashService: HashService, private talentInsightsService: TalentInsightsService) { }
  companyDetails: any;
  currentCompanyName: any;
  school: any = [];
  schoolData: any = [];
  schoolNames: any;
  @ViewChild('educationTbSort') schoolsTbSort: MatSort; 
  displayedColumns: string[] = ['key', 'doc_count' ,'recentGraduate', 'graph'];
  totalResultCount: number = 0;
  startindex: number = 0;
  education: any = [];
  fieldOfStudy: any = [];
  aggregatescount: number = 50;
  isViewMore: boolean = true;
  showSchoolLoader: boolean = true;
  showEducationLoader: boolean = true;
  showFieldOfStudyLoader: boolean = true;
  totalSchoolCount:any;
  recentGraduated: any [] = [];

  pagination: boolean = true;
  pageSize = 10;
  start: number = 0;
  end: number = 10;
  currentPage = 1;
  totalCount = 0;
  talentfilterdata: any = {};
  subscriptions: Array<Subscription> = [];

  /**School sorted data for shown pages */
  schoolsSortData = [];
  /**Recent Graduate data called or not */
  isRecentGraduateData: boolean = false;
  schoolsdata: any = []
  schoolsdataAI: any = {}
  educationdata: any = [];
  fieldofstudydata: any = [];
  insightsExportSubscription: Subscription = null;

  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
    // const educationsubscription = this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(educationsubscription);

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
   // this.getTotalSchoolCount();
    this.getSchool();
    this.getEducation();
    this.getFieldOfStudy();    
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getSchool();
    }
    else{
      this.manualSort();
    }
  }

  getSchoolTotalPercentage(value) {
   const p = ((value / this.totalSchoolCount) * 100).toFixed(2);
    if(p){
      return p
    }
  }


  getSchool() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.totalResultCount = response.data.totalresultscount;
      this.totalSchoolCount = response.data.totalresultscount;
      this.showSchoolLoader = false;
      const filterSchool = this.talentfilterdata && this.talentfilterdata.school && this.talentfilterdata.school.length ? this.talentfilterdata.school: [];
      const tempData = filterSchool.length ? response.data.aggregations.school.filter(x => filterSchool.includes(x.key)) : response.data.aggregations.school;
      this.totalCount = tempData.length;

      this.schoolsSortData = tempData;
      this.schoolNames = _.pluck(this.schoolsSortData, 'key');

      this.schoolData = tempData.slice(this.start, this.end);
      this.school = new MatTableDataSource(this.schoolData);
      this.school.sort = this.schoolsTbSort;
      this.isRecentGraduateData = false;
      this.getRecentGraduated()
      this.manualSort();
    });
  }

  manualSort(){
    this.reSortArr(this.schoolsTbSort);
  }

  /**Sort the data including all shown pages */
  reSortArr(sort){
    const data = this.schoolsSortData;
    if(!sort || !sort.active || sort.direction === ''){
      this.schoolData = data.slice(this.start, this.end);
      this.school = new MatTableDataSource(this.schoolData);
      this.school.sort = this.schoolsTbSort;
      return;
    }

    this.schoolsSortData = data.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch(sort.active){
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'recentGraduate': return this.compare(a.recentGraduate, b.recentGraduate, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
      }
    });

    this.schoolData = this.schoolsSortData.slice(this.start, this.end);
    this.school = new MatTableDataSource(this.schoolData);
    this.school.sort = this.schoolsTbSort;
  }

  compare(a:number, b:number, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  
  getRecentGraduated(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'recentgraduate-school';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.recentgraduatesonly = true;
    aggReq.resultsize = 5;
    aggReq.startindex = 0;
    aggReq.schools = this.schoolNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((res) => {
      if(res && res.data && res.data.aggregations && res.data.aggregations['recentgraduate-school']){
        const tempData = res.data.aggregations['recentgraduate-school'];
        
        this.schoolsSortData.map(res=>{
          const filteredData = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
          res.recentGraduate = filteredData && filteredData.doc_count ? filteredData.doc_count : 0;
          this.isRecentGraduateData = true;
          return res;
        })
        this.getschoolsdataai(this.schoolsSortData, 'schools')
      }
    });
  }

  getEducation() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "education";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      const data = response.data.aggregations.education.slice(0, 5);
      this.getschoolsdataai(response.data.aggregations.education, 'educations')
      this.showEducationLoader = false;

      const ChartForExpInCurrentRole = [];
      data && data.forEach(x => {
        let dataObj = {
          label: this.convertToTitleCase(x.key),
          // label: this.titleCasePipe.transform(x.key),
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        ChartForExpInCurrentRole.push(dataObj)
      });

      this.education = {
        type: "column2d",
        dataFormat: "json",
        height: 85,
        width: 1000,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#86db94, #eceff4, #eceff4, #eceff4, #eceff4",
          showPercentValues: "1",
          yAxisNameFontColor: '#2C2C2C',
          legendPosition: "right",
          legendAllowDrag: "1",
          theme: "fusion",
          showValues: '1',
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          legendItemFont: "Poppins"
        },
        "data": ChartForExpInCurrentRole
      }

    });
  }

  getFieldOfStudy() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      const data = response.data.aggregations.fieldofstudy;
      this.showFieldOfStudyLoader = false;
      const CharForSeniority = [];
      let colorData = ["#008000", "#000", "#eacc39", "#8585dd", "#e23b80", "#aaaaaa"," #95e1d3", "#1B4E6B", "#3934a5", "#86db94",]
      data && data.forEach((x, i) => {
        const color = colorData[i % colorData.length];
        let dataObj = {
          label: this.convertToTitleCase(x.key),
          value: x.doc_count,
          tooltext: `${this.convertToTitleCase(x.key)} <br> Talent Count: ${x.doc_count}`,
          color: color,
        }
        CharForSeniority.push(dataObj)
      })

      this.fieldOfStudy = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#008000, #000, #eacc39, #8585dd, #e23b80, #aaaaaa, #95e1d3, #1B4E6B, #3934a5, #86db94",
          "subCaption": "",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          "enableSmartLabels":"1",
          "manageLabelOverflow":"1",
          "useEllipsesWhenOverflow":"1",
          "legendPosition": "right",
          "legendAllowDrag": "0",
          "theme": "fusion",
          "legendWidth": "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          "legendItemFont": "Poppins",
        },
        "data": CharForSeniority
      }
    });
  }

  getTotalSchoolCount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.startindex = 0;
    aggReq.calledfrom = "listing";
    aggReq.resultsize = 10;
    aggReq.currentcompaniesonly = false;
    aggReq.fullnames = [];
    aggReq.iscurrent = false;
    aggReq.pastcompaniesonly = false;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getPersonSearchRecommendCandidates(aggReq).subscribe((res:any)=>{
      if(res && res.data){
        this.totalSchoolCount = res.data.totalresultscount;
      }
    })
  }

convertToTitleCase(stringName){
  stringName = stringName.toLowerCase().split(' ');
  for(let i = 0;i<stringName.length;i++){
    stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
  }
  return stringName.join(' ');
}

ngOnDestroy() {
  this.subscriptions.forEach(sub => sub.unsubscribe());
}

/**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'school': additionalFilters['mandatoryschools'] = [key]; break;
      case 'recentgraduatesonly': {
        additionalFilters['mandatoryschools'] = [key];
        additionalFilters['recentgraduatesonly'] = true; 
        break;
      }
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getschoolsdataai(data, type) {
    this.schoolsdataAI = {};
    if(type == 'schools') {
        
      this.schoolsdata = data.map(x=>{
        let res: any ={};
        res['Schools'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Recent Graduate'] = x.recentGraduate;
        res['% of Total'] = this.getSchoolTotalPercentage(x.doc_count)+'%';
        return res;
      });
      if(this.schoolsdata.length > 0)
        this.schoolsdataAI['schools'] = this.schoolsdata;
    } if(type == 'educations') {
      this.educationdata = data.map(x=>{
        let res:any = {};
        res['Qualifications'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
      if(this.educationdata.length > 0)
      this.schoolsdataAI['educations'] = this.educationdata;
    } if(type == 'fieldofstudy') {
      this.fieldofstudydata = data.map(x=>{
        let res:any = {};
        res['Field of Study'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
      if(this.fieldofstudydata.length > 0)
      this.schoolsdataAI['fieldofstudies'] = this.fieldofstudydata;
    }
    if(this.schoolsdata.length == 0 && this.educationdata.length == 0 && this.fieldofstudydata.length == 0)
      this.schoolsdataAI = null;
  
  }
  
  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'education') return;

    // education chart config
    const educationChart = { renderAt: 'education', type: 'column2d', dataSource: { ...this.education } };
    educationChart['type'] = educationChart['dataSource']['type'];
    delete educationChart['dataSource']['type'];
    delete educationChart['dataSource']['width'];
    delete educationChart['dataSource']['chart']['width'];
    delete educationChart['dataSource']['height'];
    delete educationChart['dataSource']['chart']['height'];
    delete educationChart['dataSource']['chart']['renderAt'];
    educationChart['width'] = '100%';

    // field-of-study chart config
    const fieldOfStudyChart = { renderAt: 'fieldofstudy', dataSource: { ...this.fieldOfStudy } };
    fieldOfStudyChart['type'] = fieldOfStudyChart['dataSource']['type'];
    delete fieldOfStudyChart['dataSource']['type'];
    delete fieldOfStudyChart['dataSource']['width'];
    delete fieldOfStudyChart['dataSource']['chart']['width'];
    delete fieldOfStudyChart['dataSource']['height'];
    delete fieldOfStudyChart['dataSource']['chart']['height'];
    fieldOfStudyChart['dataSource']['chart']['legendPosition'] = 'bottom';
    fieldOfStudyChart['dataSource']['chart']['legendNumColumns'] = '4';
    fieldOfStudyChart['width'] = '100%';

    const payloadForInsightsExport = {
      tab: 'education',
      totalresultcount: this.totalResultCount,
      school: this.schoolsSortData,
      chartdetails: [educationChart, fieldOfStudyChart]
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
